import React from 'react';
import { Result, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const ProjectCompleted = () => {
  return (
    <div
      style={{
        padding: '50px',
        background: '#001e3c',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Result
        icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
        title={<span style={{ color: '#fff' }}>Assessment Completed Successfully</span>}
        subTitle={
          <span style={{ color: '#ccc' }}>
            Congratulations! You have successfully completed your assessment. Your submission has
            been recorded. You can now close this window
          </span>
        }
      />
    </div>
  );
};

export default ProjectCompleted;
